import { render } from "./CompaniesToolbar.vue?vue&type=template&id=4d905a60&scoped=true&ts=true"
import script from "./CompaniesToolbar.vue?vue&type=script&lang=ts"
export * from "./CompaniesToolbar.vue?vue&type=script&lang=ts"

import "./CompaniesToolbar.vue?vue&type=style&index=0&id=4d905a60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d905a60"]])

export default __exports__